export default __webpack_public_path__ + "static/media/s.76264815.jpg";